module.exports = __webpack_public_path__ + "img/guzhang.c36a5c07.png";